// extracted by mini-css-extract-plugin
module.exports = {"videoPlayer":"VideoPlayer_videoPlayer__34pjn","responsiveIframe":"VideoPlayer_responsiveIframe__fREQ_"};